import React from 'react';
import { Box, IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { STANDARD_KABOB_HEIGHT } from "../../../constants/CommonConstants";


interface IActionCellRendererProps {
    id: number;
    isRequired: boolean;
    handleDelete: (id: number) => void;
}

const ActionCellRenderer: React.FC<IActionCellRendererProps> = ({ id, isRequired, handleDelete }) => {

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget); // Anchor to the button
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton
                aria-label="more"
                id={"long-button-" + id}
                sx={{ padding: "0" }}
                onClick={(event: React.MouseEvent<HTMLElement>) => {
                    handleClick(event);
                }}
            >
                <MoreHorizIcon />
            </IconButton>
            <Menu
                id={"long-menu-" + id}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClick={handleClose}
                onClose={handleClose}
                MenuListProps={{
                    "aria-labelledby": "long-button-" + id
                }}
                PaperProps={{
                    style: {
                        maxHeight: STANDARD_KABOB_HEIGHT * 4.5,
                        width: "20ch",
                    },
                }}
            >
                <Box>
                    <Tooltip placement="left-end"
                        title={isRequired ? "Required Field" : ""}
                        disableHoverListener={!isRequired}
                        PopperProps={{
                            modifiers: [
                                {
                                    name: 'offset',
                                    options: {
                                        offset: [0, -15], // Adjust the offset to move the tooltip closer
                                    },
                                },
                            ]
                        }}
                    >
                        <span>
                            <MenuItem
                                disabled={isRequired}
                                onClick={() => {
                                    handleDelete(id);
                                }}
                            >
                                <Typography>Remove</Typography>
                            </MenuItem>
                        </span>
                    </Tooltip>
                </Box>
            </Menu>
        </>
    );
};

export default ActionCellRenderer;
